import React, { useState } from "react";
import {Link, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image"
import LayoutComponent from "../components/global/layout";
import LatestBlogPostsComponent from "../components/blog/latest-posts";
import LatestNotesComponent from "../components/notes/latest";
import SEOComponent from "../components/global/seo";

const IndexPage = ({ data }) => {  
  const [activeTab, setActiveTab] = useState("posts");

  return (
    <LayoutComponent>
      <SEOComponent title="Surinder Bhomra | Coder and Blogger based in Oxford" shareImageIsLarge={true} />
      <div className="divide-y divide-gray-200 dark:divide-gray-700 mt-8 md:mt-16">
        <div className="my-4 pt-6 pb-8 space-y-2 md:space-y-5 xl:grid xl:grid-cols-3">
          <div className="xl:col-span-2 pr-8">
            <p
              className="pb-6 text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
              Hi, I'm Surinder! <i className="twa twa-waving-hand"></i>
            </p>
            <div className="text-lg leading-8 text-gray-600 dark:text-gray-400">
              <h1 className="text-neutral-900 dark:text-neutral-200">
                A Web and Software Developer based in Oxford delivering CMS and custom build solutions to a wide variety of high profile clients.
              </h1>
              <p className="mt-4 mb-8 hidden sm:block">
                With around 15 years experience in the industry, I am just as passionate about coding as I was from the very first console app I created many moons ago that read out: "Hello World!".
              </p>
              <p className="my-8 hidden sm:block">
                I hope you enjoy your stay.
              </p>
            </div>
          </div>
          <div className="hidden xl:block">
            <div className="block items-center justify-between">
              <div className="flex justify-center items-center mb-3">
                <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} className="gatsby-image-rounded" alt="Surinder Bhomra" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden flex justify-between pb-4 md:pb-8">
        <div className="space-y-4">
            <h2 className="flex font-bold text-3xl">
              <span className="mr-2 md:mr-3">Latest</span>
              <button 
                type="button" 
                onClick={() => setActiveTab("posts")}
                className={`transition-colors ${
                  activeTab === "posts"
                    ? "underline text-gray-900 dark:text-gray-200" // Active Styles
                    : "text-gray-300 hover:text-gray-900 dark:text-gray-500 dark:hover:text-gray-200" // Inactive Styles
                }`}
              >
                <span className="bg-linear-to-r bg-bottom-left bg-no-repeat transition-[background-size] duration-(--duration,300ms) hover:bg-size-[100%_50%]">posts</span>
              </button>
              <span className="mx-1">/</span>
              <button 
                type="button" 
                onClick={() => setActiveTab("notes")}
                className={`transition-colors ${
                  activeTab === "notes"
                    ? "underline text-gray-900 dark:text-gray-200" // Active Styles
                    : "text-gray-300 hover:text-gray-900 dark:text-gray-500 dark:hover:text-gray-200" // Inactive Styles
                }`}
              >
                <span className="bg-linear-to-r bg-bottom-left bg-no-repeat transition-[background-size] duration-(--duration,300ms) bg-size-[0px_50%] hover:bg-size-[100%_50%]">notes</span>
              </button>
            </h2>
        </div>
        <div className="pt-2 items-center justify-end text-base leading-6 font-medium">
          <Link 
            aria-label={activeTab === "posts" ? "All posts" : "All notes"} 
            to={activeTab === "posts" ? "/Blog" : "/Notes"} // Update URL based on tab
          >
            <span className="bg-linear-to-r bg-bottom-left bg-no-repeat transition-[background-size] duration-(--duration,300ms) bg-size-[0px_50%] hover:bg-size-[100%_50%]">
              <span className="hidden md:inline-block">View all {activeTab}</span>
              <span className="md:hidden">More</span> →
            </span>
          </Link>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-14">
        <div className={activeTab === "posts" ? "block" : "hidden md:block"}>
          <LatestBlogPostsComponent data={data.posts} />
        </div>
        <div className={activeTab === "notes" ? "block" : "hidden md:block"}>
          <LatestNotesComponent data={data.notes} />
        </div>
      </div>
    </LayoutComponent>
  )
}

export const query = graphql`
  query latestBlogPostsList {
    posts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {frontmatter: {draft: {eq: false}}, fields: {type: {eq: "post"}}},
      limit: 3
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            summary
            date
          }
        }
      }
    }
    notes: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { type: { eq: "note" }} },
      limit: 5
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            summary
            date
            externalSourceUrl
          }
        }
      }
    }
    file(relativePath: {eq: "logo-me-retro.png"}) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, height: 350)
      }
    }
  }
`

export default IndexPage
